/**
 * DOM Reconciler Patch (iter100)
 *
 * Fix per l'errore React tipico:
 *   "Failed to execute 'removeChild' on 'Node': The node to be removed is
 *    not a child of this node."
 *
 * CAUSA: estensioni browser che modificano il DOM al di fuori del ciclo
 * React (Google Translate, LanguageTool, Grammarly, ecc.) — spostano nodi
 * di testo e quando React prova a rimuoverli il parentNode è cambiato.
 *
 * SOLUZIONE canonica: intercettare Node.prototype.removeChild e
 * insertBefore. Se il nodo non appartiene più al parent atteso, invece di
 * lanciare eccezione facciamo il no-op / append silente. Questo è ciò che
 * fanno praticamente tutti i workaround pubblici (facebook/react#11538,
 * next.js, Trello, ecc.).
 *
 * Deve essere importato PRIMA di React.render.
 */

let installed = false;

export function installDomReconcilerPatch() {
  if (installed || typeof Node === 'undefined') return;
  installed = true;

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function patchedRemoveChild(child) {
    if (child && child.parentNode !== this) {
      // Nodo già rimosso/spostato da un'estensione. No-op silente per
      // evitare che React crashi durante la reconciliazione.
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('[dom-patch] removeChild ignorato (nodo non figlio)');
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function patchedInsertBefore(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      // Reference spostata da un'estensione — fallback ad appendChild.
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('[dom-patch] insertBefore -> appendChild (reference non figlio)');
      }
      return this.appendChild(newNode);
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

export default installDomReconcilerPatch;
